// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"af292fe6","686":"2ced5bc8","746":"d39b21b3","858":"18eabd80"}[chunkId] + ".chunk.js";
};